/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as SplatRouteImport } from './pages/$'
import { Route as CertificatesRouteImport } from './pages/certificates'
import { Route as Template_traceRouteImport } from './pages/template_trace'
import { Route as EventsMcnProjectRouteImport } from './pages/events/mcn-project'
import { Route as F2aIndexRouteImport } from './pages/f2a/index'
import { Route as F2aIdRouteImport } from './pages/f2a/id'
import { Route as F2aOtpRouteImport } from './pages/f2a/otp'
import { Route as HelpIndexRouteImport } from './pages/help/index'
import { Route as HelpFeedbackRouteImport } from './pages/help/feedback'
import { Route as NoticeSpan_warningRouteImport } from './pages/notice/span_warning'
import { Route as ReportIndexRouteImport } from './pages/report/index'
import { Route as ReportDetailRouteImport } from './pages/report/detail'
import { Route as ResultFailRouteImport } from './pages/result/fail'
import { Route as ResultSuccessRouteImport } from './pages/result/success'
import { Route as Template_protectionsIndexRouteImport } from './pages/template_protections/index'
import { Route as Template_protectionsBlacklistLayoutRouteImport } from './pages/template_protections/blacklist/layout'
import { Route as Template_protectionsSendRouteImport } from './pages/template_protections/send'
import { Route as Template_protectionsStorageRouteImport } from './pages/template_protections/storage'
import { Route as Template_protectionsTrustedQueryRouteImport } from './pages/template_protections/trusted-query'
import { Route as Template_protectionsUploadRouteImport } from './pages/template_protections/upload'
import { Route as TermsPageRouteImport } from './pages/terms/$page'
import { Route as HelpAccount_recoveryFace_verifyRouteImport } from './pages/help/account_recovery/face_verify'
import { Route as HelpAccount_recoveryIdRouteImport } from './pages/help/account_recovery/id'
import { Route as HelpAccount_recoveryMenuRouteImport } from './pages/help/account_recovery/menu'
import { Route as HelpAccount_recoveryPhoneRouteImport } from './pages/help/account_recovery/phone'
import { Route as HelpTutorialsMarketRouteImport } from './pages/help/tutorials/market'
import { Route as HelpTutorialsPublic_auditRouteImport } from './pages/help/tutorials/public_audit'
import { Route as Template_protectionsBlacklistIndexRouteImport } from './pages/template_protections/blacklist/index'
import { Route as Template_protectionsBlacklistRulesRouteImport } from './pages/template_protections/blacklist/rules'
import { Route as Template_protectionsBlacklistSelfRouteImport } from './pages/template_protections/blacklist/self'
import { Route as Template_protectionsBlacklistSubscribedRouteImport } from './pages/template_protections/blacklist/subscribed'
import { Route as Template_protectionsDetailTemplateIdRouteImport } from './pages/template_protections/detail/$templateId'
import { Route as Template_protectionsEditTemplateIdRouteImport } from './pages/template_protections/edit/$templateId'
import { Route as Template_protectionsHistoryReceivedRouteImport } from './pages/template_protections/history/received'
import { Route as Template_protectionsHistorySentRouteImport } from './pages/template_protections/history/sent'
import { Route as UserAccountChangePassRouteImport } from './pages/user/account/changePass'
import { Route as UserAccountDisableRouteImport } from './pages/user/account/disable'
import { Route as UserAccountRecoveryRouteImport } from './pages/user/account/recovery'
import { Route as UserAccountRecovery_phoneRouteImport } from './pages/user/account/recovery_phone'
import { Route as UserAccountUpdatePhoneRouteImport } from './pages/user/account/updatePhone'
import { Route as UserBadgesIndexRouteImport } from './pages/user/badges/index'
import { Route as UserBadgesIdRouteImport } from './pages/user/badges/$id'
import { Route as HelpTutorialsUserAppUsageRouteImport } from './pages/help/tutorials/user/app-usage'
import { Route as Template_protectionsBlacklistPublicIndexRouteImport } from './pages/template_protections/blacklist/public/index'
import { Route as Template_protectionsBlacklistPublicIdRouteImport } from './pages/template_protections/blacklist/public/$id'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const CertificatesRoute = CertificatesRouteImport.update({
  id: '/certificates',
  path: '/certificates',
  getParentRoute: () => rootRouteImport,
} as any)
const Template_traceRoute = Template_traceRouteImport.update({
  id: '/template_trace',
  path: '/template_trace',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsMcnProjectRoute = EventsMcnProjectRouteImport.update({
  id: '/events/mcn-project',
  path: '/events/mcn-project',
  getParentRoute: () => rootRouteImport,
} as any)
const F2aIndexRoute = F2aIndexRouteImport.update({
  id: '/f2a/',
  path: '/f2a/',
  getParentRoute: () => rootRouteImport,
} as any)
const F2aIdRoute = F2aIdRouteImport.update({
  id: '/f2a/id',
  path: '/f2a/id',
  getParentRoute: () => rootRouteImport,
} as any)
const F2aOtpRoute = F2aOtpRouteImport.update({
  id: '/f2a/otp',
  path: '/f2a/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpIndexRoute = HelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpFeedbackRoute = HelpFeedbackRouteImport.update({
  id: '/help/feedback',
  path: '/help/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const NoticeSpan_warningRoute = NoticeSpan_warningRouteImport.update({
  id: '/notice/span_warning',
  path: '/notice/span_warning',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportIndexRoute = ReportIndexRouteImport.update({
  id: '/report/',
  path: '/report/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportDetailRoute = ReportDetailRouteImport.update({
  id: '/report/detail',
  path: '/report/detail',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultFailRoute = ResultFailRouteImport.update({
  id: '/result/fail',
  path: '/result/fail',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultSuccessRoute = ResultSuccessRouteImport.update({
  id: '/result/success',
  path: '/result/success',
  getParentRoute: () => rootRouteImport,
} as any)
const Template_protectionsIndexRoute =
  Template_protectionsIndexRouteImport.update({
    id: '/template_protections/',
    path: '/template_protections/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Template_protectionsBlacklistLayoutRoute =
  Template_protectionsBlacklistLayoutRouteImport.update({
    id: '/template_protections/blacklist',
    path: '/template_protections/blacklist',
    getParentRoute: () => rootRouteImport,
  } as any)
const Template_protectionsSendRoute =
  Template_protectionsSendRouteImport.update({
    id: '/template_protections/send',
    path: '/template_protections/send',
    getParentRoute: () => rootRouteImport,
  } as any)
const Template_protectionsStorageRoute =
  Template_protectionsStorageRouteImport.update({
    id: '/template_protections/storage',
    path: '/template_protections/storage',
    getParentRoute: () => rootRouteImport,
  } as any)
const Template_protectionsTrustedQueryRoute =
  Template_protectionsTrustedQueryRouteImport.update({
    id: '/template_protections/trusted-query',
    path: '/template_protections/trusted-query',
    getParentRoute: () => rootRouteImport,
  } as any)
const Template_protectionsUploadRoute =
  Template_protectionsUploadRouteImport.update({
    id: '/template_protections/upload',
    path: '/template_protections/upload',
    getParentRoute: () => rootRouteImport,
  } as any)
const TermsPageRoute = TermsPageRouteImport.update({
  id: '/terms/$page',
  path: '/terms/$page',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpAccount_recoveryFace_verifyRoute =
  HelpAccount_recoveryFace_verifyRouteImport.update({
    id: '/help/account_recovery/face_verify',
    path: '/help/account_recovery/face_verify',
    getParentRoute: () => rootRouteImport,
  } as any)
const HelpAccount_recoveryIdRoute = HelpAccount_recoveryIdRouteImport.update({
  id: '/help/account_recovery/id',
  path: '/help/account_recovery/id',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpAccount_recoveryMenuRoute =
  HelpAccount_recoveryMenuRouteImport.update({
    id: '/help/account_recovery/menu',
    path: '/help/account_recovery/menu',
    getParentRoute: () => rootRouteImport,
  } as any)
const HelpAccount_recoveryPhoneRoute =
  HelpAccount_recoveryPhoneRouteImport.update({
    id: '/help/account_recovery/phone',
    path: '/help/account_recovery/phone',
    getParentRoute: () => rootRouteImport,
  } as any)
const HelpTutorialsMarketRoute = HelpTutorialsMarketRouteImport.update({
  id: '/help/tutorials/market',
  path: '/help/tutorials/market',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpTutorialsPublic_auditRoute =
  HelpTutorialsPublic_auditRouteImport.update({
    id: '/help/tutorials/public_audit',
    path: '/help/tutorials/public_audit',
    getParentRoute: () => rootRouteImport,
  } as any)
const Template_protectionsBlacklistIndexRoute =
  Template_protectionsBlacklistIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => Template_protectionsBlacklistLayoutRoute,
  } as any)
const Template_protectionsBlacklistRulesRoute =
  Template_protectionsBlacklistRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => Template_protectionsBlacklistLayoutRoute,
  } as any)
const Template_protectionsBlacklistSelfRoute =
  Template_protectionsBlacklistSelfRouteImport.update({
    id: '/self',
    path: '/self',
    getParentRoute: () => Template_protectionsBlacklistLayoutRoute,
  } as any)
const Template_protectionsBlacklistSubscribedRoute =
  Template_protectionsBlacklistSubscribedRouteImport.update({
    id: '/subscribed',
    path: '/subscribed',
    getParentRoute: () => Template_protectionsBlacklistLayoutRoute,
  } as any)
const Template_protectionsDetailTemplateIdRoute =
  Template_protectionsDetailTemplateIdRouteImport.update({
    id: '/template_protections/detail/$templateId',
    path: '/template_protections/detail/$templateId',
    getParentRoute: () => rootRouteImport,
  } as any)
const Template_protectionsEditTemplateIdRoute =
  Template_protectionsEditTemplateIdRouteImport.update({
    id: '/template_protections/edit/$templateId',
    path: '/template_protections/edit/$templateId',
    getParentRoute: () => rootRouteImport,
  } as any)
const Template_protectionsHistoryReceivedRoute =
  Template_protectionsHistoryReceivedRouteImport.update({
    id: '/template_protections/history/received',
    path: '/template_protections/history/received',
    getParentRoute: () => rootRouteImport,
  } as any)
const Template_protectionsHistorySentRoute =
  Template_protectionsHistorySentRouteImport.update({
    id: '/template_protections/history/sent',
    path: '/template_protections/history/sent',
    getParentRoute: () => rootRouteImport,
  } as any)
const UserAccountChangePassRoute = UserAccountChangePassRouteImport.update({
  id: '/user/account/changePass',
  path: '/user/account/changePass',
  getParentRoute: () => rootRouteImport,
} as any)
const UserAccountDisableRoute = UserAccountDisableRouteImport.update({
  id: '/user/account/disable',
  path: '/user/account/disable',
  getParentRoute: () => rootRouteImport,
} as any)
const UserAccountRecoveryRoute = UserAccountRecoveryRouteImport.update({
  id: '/user/account/recovery',
  path: '/user/account/recovery',
  getParentRoute: () => rootRouteImport,
} as any)
const UserAccountRecovery_phoneRoute =
  UserAccountRecovery_phoneRouteImport.update({
    id: '/user/account/recovery_phone',
    path: '/user/account/recovery_phone',
    getParentRoute: () => rootRouteImport,
  } as any)
const UserAccountUpdatePhoneRoute = UserAccountUpdatePhoneRouteImport.update({
  id: '/user/account/updatePhone',
  path: '/user/account/updatePhone',
  getParentRoute: () => rootRouteImport,
} as any)
const UserBadgesIndexRoute = UserBadgesIndexRouteImport.update({
  id: '/user/badges/',
  path: '/user/badges/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserBadgesIdRoute = UserBadgesIdRouteImport.update({
  id: '/user/badges/$id',
  path: '/user/badges/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpTutorialsUserAppUsageRoute =
  HelpTutorialsUserAppUsageRouteImport.update({
    id: '/help/tutorials/user/app-usage',
    path: '/help/tutorials/user/app-usage',
    getParentRoute: () => rootRouteImport,
  } as any)
const Template_protectionsBlacklistPublicIndexRoute =
  Template_protectionsBlacklistPublicIndexRouteImport.update({
    id: '/public/',
    path: '/public/',
    getParentRoute: () => Template_protectionsBlacklistLayoutRoute,
  } as any)
const Template_protectionsBlacklistPublicIdRoute =
  Template_protectionsBlacklistPublicIdRouteImport.update({
    id: '/public/$id',
    path: '/public/$id',
    getParentRoute: () => Template_protectionsBlacklistLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/certificates': typeof CertificatesRoute
  '/template_trace': typeof Template_traceRoute
  '/template_protections/blacklist': typeof Template_protectionsBlacklistLayoutRouteWithChildren
  '/events/mcn-project': typeof EventsMcnProjectRoute
  '/f2a/id': typeof F2aIdRoute
  '/f2a/otp': typeof F2aOtpRoute
  '/help/feedback': typeof HelpFeedbackRoute
  '/notice/span_warning': typeof NoticeSpan_warningRoute
  '/report/detail': typeof ReportDetailRoute
  '/result/fail': typeof ResultFailRoute
  '/result/success': typeof ResultSuccessRoute
  '/template_protections/send': typeof Template_protectionsSendRoute
  '/template_protections/storage': typeof Template_protectionsStorageRoute
  '/template_protections/trusted-query': typeof Template_protectionsTrustedQueryRoute
  '/template_protections/upload': typeof Template_protectionsUploadRoute
  '/terms/$page': typeof TermsPageRoute
  '/f2a/': typeof F2aIndexRoute
  '/help/': typeof HelpIndexRoute
  '/report/': typeof ReportIndexRoute
  '/template_protections/': typeof Template_protectionsIndexRoute
  '/help/account_recovery/face_verify': typeof HelpAccount_recoveryFace_verifyRoute
  '/help/account_recovery/id': typeof HelpAccount_recoveryIdRoute
  '/help/account_recovery/menu': typeof HelpAccount_recoveryMenuRoute
  '/help/account_recovery/phone': typeof HelpAccount_recoveryPhoneRoute
  '/help/tutorials/market': typeof HelpTutorialsMarketRoute
  '/help/tutorials/public_audit': typeof HelpTutorialsPublic_auditRoute
  '/template_protections/blacklist/rules': typeof Template_protectionsBlacklistRulesRoute
  '/template_protections/blacklist/self': typeof Template_protectionsBlacklistSelfRoute
  '/template_protections/blacklist/subscribed': typeof Template_protectionsBlacklistSubscribedRoute
  '/template_protections/detail/$templateId': typeof Template_protectionsDetailTemplateIdRoute
  '/template_protections/edit/$templateId': typeof Template_protectionsEditTemplateIdRoute
  '/template_protections/history/received': typeof Template_protectionsHistoryReceivedRoute
  '/template_protections/history/sent': typeof Template_protectionsHistorySentRoute
  '/user/account/changePass': typeof UserAccountChangePassRoute
  '/user/account/disable': typeof UserAccountDisableRoute
  '/user/account/recovery': typeof UserAccountRecoveryRoute
  '/user/account/recovery_phone': typeof UserAccountRecovery_phoneRoute
  '/user/account/updatePhone': typeof UserAccountUpdatePhoneRoute
  '/user/badges/$id': typeof UserBadgesIdRoute
  '/template_protections/blacklist/': typeof Template_protectionsBlacklistIndexRoute
  '/user/badges/': typeof UserBadgesIndexRoute
  '/help/tutorials/user/app-usage': typeof HelpTutorialsUserAppUsageRoute
  '/template_protections/blacklist/public/$id': typeof Template_protectionsBlacklistPublicIdRoute
  '/template_protections/blacklist/public/': typeof Template_protectionsBlacklistPublicIndexRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/certificates': typeof CertificatesRoute
  '/template_trace': typeof Template_traceRoute
  '/events/mcn-project': typeof EventsMcnProjectRoute
  '/f2a/id': typeof F2aIdRoute
  '/f2a/otp': typeof F2aOtpRoute
  '/help/feedback': typeof HelpFeedbackRoute
  '/notice/span_warning': typeof NoticeSpan_warningRoute
  '/report/detail': typeof ReportDetailRoute
  '/result/fail': typeof ResultFailRoute
  '/result/success': typeof ResultSuccessRoute
  '/template_protections/send': typeof Template_protectionsSendRoute
  '/template_protections/storage': typeof Template_protectionsStorageRoute
  '/template_protections/trusted-query': typeof Template_protectionsTrustedQueryRoute
  '/template_protections/upload': typeof Template_protectionsUploadRoute
  '/terms/$page': typeof TermsPageRoute
  '/f2a': typeof F2aIndexRoute
  '/help': typeof HelpIndexRoute
  '/report': typeof ReportIndexRoute
  '/template_protections': typeof Template_protectionsIndexRoute
  '/help/account_recovery/face_verify': typeof HelpAccount_recoveryFace_verifyRoute
  '/help/account_recovery/id': typeof HelpAccount_recoveryIdRoute
  '/help/account_recovery/menu': typeof HelpAccount_recoveryMenuRoute
  '/help/account_recovery/phone': typeof HelpAccount_recoveryPhoneRoute
  '/help/tutorials/market': typeof HelpTutorialsMarketRoute
  '/help/tutorials/public_audit': typeof HelpTutorialsPublic_auditRoute
  '/template_protections/blacklist/rules': typeof Template_protectionsBlacklistRulesRoute
  '/template_protections/blacklist/self': typeof Template_protectionsBlacklistSelfRoute
  '/template_protections/blacklist/subscribed': typeof Template_protectionsBlacklistSubscribedRoute
  '/template_protections/detail/$templateId': typeof Template_protectionsDetailTemplateIdRoute
  '/template_protections/edit/$templateId': typeof Template_protectionsEditTemplateIdRoute
  '/template_protections/history/received': typeof Template_protectionsHistoryReceivedRoute
  '/template_protections/history/sent': typeof Template_protectionsHistorySentRoute
  '/user/account/changePass': typeof UserAccountChangePassRoute
  '/user/account/disable': typeof UserAccountDisableRoute
  '/user/account/recovery': typeof UserAccountRecoveryRoute
  '/user/account/recovery_phone': typeof UserAccountRecovery_phoneRoute
  '/user/account/updatePhone': typeof UserAccountUpdatePhoneRoute
  '/user/badges/$id': typeof UserBadgesIdRoute
  '/template_protections/blacklist': typeof Template_protectionsBlacklistIndexRoute
  '/user/badges': typeof UserBadgesIndexRoute
  '/help/tutorials/user/app-usage': typeof HelpTutorialsUserAppUsageRoute
  '/template_protections/blacklist/public/$id': typeof Template_protectionsBlacklistPublicIdRoute
  '/template_protections/blacklist/public': typeof Template_protectionsBlacklistPublicIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/certificates': typeof CertificatesRoute
  '/template_trace': typeof Template_traceRoute
  '/template_protections/blacklist': typeof Template_protectionsBlacklistLayoutRouteWithChildren
  '/events/mcn-project': typeof EventsMcnProjectRoute
  '/f2a/id': typeof F2aIdRoute
  '/f2a/otp': typeof F2aOtpRoute
  '/help/feedback': typeof HelpFeedbackRoute
  '/notice/span_warning': typeof NoticeSpan_warningRoute
  '/report/detail': typeof ReportDetailRoute
  '/result/fail': typeof ResultFailRoute
  '/result/success': typeof ResultSuccessRoute
  '/template_protections/send': typeof Template_protectionsSendRoute
  '/template_protections/storage': typeof Template_protectionsStorageRoute
  '/template_protections/trusted-query': typeof Template_protectionsTrustedQueryRoute
  '/template_protections/upload': typeof Template_protectionsUploadRoute
  '/terms/$page': typeof TermsPageRoute
  '/f2a/': typeof F2aIndexRoute
  '/help/': typeof HelpIndexRoute
  '/report/': typeof ReportIndexRoute
  '/template_protections/': typeof Template_protectionsIndexRoute
  '/help/account_recovery/face_verify': typeof HelpAccount_recoveryFace_verifyRoute
  '/help/account_recovery/id': typeof HelpAccount_recoveryIdRoute
  '/help/account_recovery/menu': typeof HelpAccount_recoveryMenuRoute
  '/help/account_recovery/phone': typeof HelpAccount_recoveryPhoneRoute
  '/help/tutorials/market': typeof HelpTutorialsMarketRoute
  '/help/tutorials/public_audit': typeof HelpTutorialsPublic_auditRoute
  '/template_protections/blacklist/rules': typeof Template_protectionsBlacklistRulesRoute
  '/template_protections/blacklist/self': typeof Template_protectionsBlacklistSelfRoute
  '/template_protections/blacklist/subscribed': typeof Template_protectionsBlacklistSubscribedRoute
  '/template_protections/detail/$templateId': typeof Template_protectionsDetailTemplateIdRoute
  '/template_protections/edit/$templateId': typeof Template_protectionsEditTemplateIdRoute
  '/template_protections/history/received': typeof Template_protectionsHistoryReceivedRoute
  '/template_protections/history/sent': typeof Template_protectionsHistorySentRoute
  '/user/account/changePass': typeof UserAccountChangePassRoute
  '/user/account/disable': typeof UserAccountDisableRoute
  '/user/account/recovery': typeof UserAccountRecoveryRoute
  '/user/account/recovery_phone': typeof UserAccountRecovery_phoneRoute
  '/user/account/updatePhone': typeof UserAccountUpdatePhoneRoute
  '/user/badges/$id': typeof UserBadgesIdRoute
  '/template_protections/blacklist/': typeof Template_protectionsBlacklistIndexRoute
  '/user/badges/': typeof UserBadgesIndexRoute
  '/help/tutorials/user/app-usage': typeof HelpTutorialsUserAppUsageRoute
  '/template_protections/blacklist/public/$id': typeof Template_protectionsBlacklistPublicIdRoute
  '/template_protections/blacklist/public/': typeof Template_protectionsBlacklistPublicIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/certificates'
    | '/template_trace'
    | '/template_protections/blacklist'
    | '/events/mcn-project'
    | '/f2a/id'
    | '/f2a/otp'
    | '/help/feedback'
    | '/notice/span_warning'
    | '/report/detail'
    | '/result/fail'
    | '/result/success'
    | '/template_protections/send'
    | '/template_protections/storage'
    | '/template_protections/trusted-query'
    | '/template_protections/upload'
    | '/terms/$page'
    | '/f2a/'
    | '/help/'
    | '/report/'
    | '/template_protections/'
    | '/help/account_recovery/face_verify'
    | '/help/account_recovery/id'
    | '/help/account_recovery/menu'
    | '/help/account_recovery/phone'
    | '/help/tutorials/market'
    | '/help/tutorials/public_audit'
    | '/template_protections/blacklist/rules'
    | '/template_protections/blacklist/self'
    | '/template_protections/blacklist/subscribed'
    | '/template_protections/detail/$templateId'
    | '/template_protections/edit/$templateId'
    | '/template_protections/history/received'
    | '/template_protections/history/sent'
    | '/user/account/changePass'
    | '/user/account/disable'
    | '/user/account/recovery'
    | '/user/account/recovery_phone'
    | '/user/account/updatePhone'
    | '/user/badges/$id'
    | '/template_protections/blacklist/'
    | '/user/badges/'
    | '/help/tutorials/user/app-usage'
    | '/template_protections/blacklist/public/$id'
    | '/template_protections/blacklist/public/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/certificates'
    | '/template_trace'
    | '/events/mcn-project'
    | '/f2a/id'
    | '/f2a/otp'
    | '/help/feedback'
    | '/notice/span_warning'
    | '/report/detail'
    | '/result/fail'
    | '/result/success'
    | '/template_protections/send'
    | '/template_protections/storage'
    | '/template_protections/trusted-query'
    | '/template_protections/upload'
    | '/terms/$page'
    | '/f2a'
    | '/help'
    | '/report'
    | '/template_protections'
    | '/help/account_recovery/face_verify'
    | '/help/account_recovery/id'
    | '/help/account_recovery/menu'
    | '/help/account_recovery/phone'
    | '/help/tutorials/market'
    | '/help/tutorials/public_audit'
    | '/template_protections/blacklist/rules'
    | '/template_protections/blacklist/self'
    | '/template_protections/blacklist/subscribed'
    | '/template_protections/detail/$templateId'
    | '/template_protections/edit/$templateId'
    | '/template_protections/history/received'
    | '/template_protections/history/sent'
    | '/user/account/changePass'
    | '/user/account/disable'
    | '/user/account/recovery'
    | '/user/account/recovery_phone'
    | '/user/account/updatePhone'
    | '/user/badges/$id'
    | '/template_protections/blacklist'
    | '/user/badges'
    | '/help/tutorials/user/app-usage'
    | '/template_protections/blacklist/public/$id'
    | '/template_protections/blacklist/public'
  id:
    | '__root__'
    | '/$'
    | '/certificates'
    | '/template_trace'
    | '/template_protections/blacklist'
    | '/events/mcn-project'
    | '/f2a/id'
    | '/f2a/otp'
    | '/help/feedback'
    | '/notice/span_warning'
    | '/report/detail'
    | '/result/fail'
    | '/result/success'
    | '/template_protections/send'
    | '/template_protections/storage'
    | '/template_protections/trusted-query'
    | '/template_protections/upload'
    | '/terms/$page'
    | '/f2a/'
    | '/help/'
    | '/report/'
    | '/template_protections/'
    | '/help/account_recovery/face_verify'
    | '/help/account_recovery/id'
    | '/help/account_recovery/menu'
    | '/help/account_recovery/phone'
    | '/help/tutorials/market'
    | '/help/tutorials/public_audit'
    | '/template_protections/blacklist/rules'
    | '/template_protections/blacklist/self'
    | '/template_protections/blacklist/subscribed'
    | '/template_protections/detail/$templateId'
    | '/template_protections/edit/$templateId'
    | '/template_protections/history/received'
    | '/template_protections/history/sent'
    | '/user/account/changePass'
    | '/user/account/disable'
    | '/user/account/recovery'
    | '/user/account/recovery_phone'
    | '/user/account/updatePhone'
    | '/user/badges/$id'
    | '/template_protections/blacklist/'
    | '/user/badges/'
    | '/help/tutorials/user/app-usage'
    | '/template_protections/blacklist/public/$id'
    | '/template_protections/blacklist/public/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  CertificatesRoute: typeof CertificatesRoute
  Template_traceRoute: typeof Template_traceRoute
  Template_protectionsBlacklistLayoutRoute: typeof Template_protectionsBlacklistLayoutRouteWithChildren
  EventsMcnProjectRoute: typeof EventsMcnProjectRoute
  F2aIdRoute: typeof F2aIdRoute
  F2aOtpRoute: typeof F2aOtpRoute
  HelpFeedbackRoute: typeof HelpFeedbackRoute
  NoticeSpan_warningRoute: typeof NoticeSpan_warningRoute
  ReportDetailRoute: typeof ReportDetailRoute
  ResultFailRoute: typeof ResultFailRoute
  ResultSuccessRoute: typeof ResultSuccessRoute
  Template_protectionsSendRoute: typeof Template_protectionsSendRoute
  Template_protectionsStorageRoute: typeof Template_protectionsStorageRoute
  Template_protectionsTrustedQueryRoute: typeof Template_protectionsTrustedQueryRoute
  Template_protectionsUploadRoute: typeof Template_protectionsUploadRoute
  TermsPageRoute: typeof TermsPageRoute
  F2aIndexRoute: typeof F2aIndexRoute
  HelpIndexRoute: typeof HelpIndexRoute
  ReportIndexRoute: typeof ReportIndexRoute
  Template_protectionsIndexRoute: typeof Template_protectionsIndexRoute
  HelpAccount_recoveryFace_verifyRoute: typeof HelpAccount_recoveryFace_verifyRoute
  HelpAccount_recoveryIdRoute: typeof HelpAccount_recoveryIdRoute
  HelpAccount_recoveryMenuRoute: typeof HelpAccount_recoveryMenuRoute
  HelpAccount_recoveryPhoneRoute: typeof HelpAccount_recoveryPhoneRoute
  HelpTutorialsMarketRoute: typeof HelpTutorialsMarketRoute
  HelpTutorialsPublic_auditRoute: typeof HelpTutorialsPublic_auditRoute
  Template_protectionsDetailTemplateIdRoute: typeof Template_protectionsDetailTemplateIdRoute
  Template_protectionsEditTemplateIdRoute: typeof Template_protectionsEditTemplateIdRoute
  Template_protectionsHistoryReceivedRoute: typeof Template_protectionsHistoryReceivedRoute
  Template_protectionsHistorySentRoute: typeof Template_protectionsHistorySentRoute
  UserAccountChangePassRoute: typeof UserAccountChangePassRoute
  UserAccountDisableRoute: typeof UserAccountDisableRoute
  UserAccountRecoveryRoute: typeof UserAccountRecoveryRoute
  UserAccountRecovery_phoneRoute: typeof UserAccountRecovery_phoneRoute
  UserAccountUpdatePhoneRoute: typeof UserAccountUpdatePhoneRoute
  UserBadgesIdRoute: typeof UserBadgesIdRoute
  UserBadgesIndexRoute: typeof UserBadgesIndexRoute
  HelpTutorialsUserAppUsageRoute: typeof HelpTutorialsUserAppUsageRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/certificates': {
      id: '/certificates'
      path: '/certificates'
      fullPath: '/certificates'
      preLoaderRoute: typeof CertificatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template_trace': {
      id: '/template_trace'
      path: '/template_trace'
      fullPath: '/template_trace'
      preLoaderRoute: typeof Template_traceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/mcn-project': {
      id: '/events/mcn-project'
      path: '/events/mcn-project'
      fullPath: '/events/mcn-project'
      preLoaderRoute: typeof EventsMcnProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/f2a/': {
      id: '/f2a/'
      path: '/f2a'
      fullPath: '/f2a/'
      preLoaderRoute: typeof F2aIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/f2a/id': {
      id: '/f2a/id'
      path: '/f2a/id'
      fullPath: '/f2a/id'
      preLoaderRoute: typeof F2aIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/f2a/otp': {
      id: '/f2a/otp'
      path: '/f2a/otp'
      fullPath: '/f2a/otp'
      preLoaderRoute: typeof F2aOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/': {
      id: '/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof HelpIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/feedback': {
      id: '/help/feedback'
      path: '/help/feedback'
      fullPath: '/help/feedback'
      preLoaderRoute: typeof HelpFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notice/span_warning': {
      id: '/notice/span_warning'
      path: '/notice/span_warning'
      fullPath: '/notice/span_warning'
      preLoaderRoute: typeof NoticeSpan_warningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/report/': {
      id: '/report/'
      path: '/report'
      fullPath: '/report/'
      preLoaderRoute: typeof ReportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/report/detail': {
      id: '/report/detail'
      path: '/report/detail'
      fullPath: '/report/detail'
      preLoaderRoute: typeof ReportDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/result/fail': {
      id: '/result/fail'
      path: '/result/fail'
      fullPath: '/result/fail'
      preLoaderRoute: typeof ResultFailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/result/success': {
      id: '/result/success'
      path: '/result/success'
      fullPath: '/result/success'
      preLoaderRoute: typeof ResultSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template_protections/': {
      id: '/template_protections/'
      path: '/template_protections'
      fullPath: '/template_protections/'
      preLoaderRoute: typeof Template_protectionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template_protections/blacklist': {
      id: '/template_protections/blacklist'
      path: '/template_protections/blacklist'
      fullPath: '/template_protections/blacklist'
      preLoaderRoute: typeof Template_protectionsBlacklistLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template_protections/send': {
      id: '/template_protections/send'
      path: '/template_protections/send'
      fullPath: '/template_protections/send'
      preLoaderRoute: typeof Template_protectionsSendRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template_protections/storage': {
      id: '/template_protections/storage'
      path: '/template_protections/storage'
      fullPath: '/template_protections/storage'
      preLoaderRoute: typeof Template_protectionsStorageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template_protections/trusted-query': {
      id: '/template_protections/trusted-query'
      path: '/template_protections/trusted-query'
      fullPath: '/template_protections/trusted-query'
      preLoaderRoute: typeof Template_protectionsTrustedQueryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template_protections/upload': {
      id: '/template_protections/upload'
      path: '/template_protections/upload'
      fullPath: '/template_protections/upload'
      preLoaderRoute: typeof Template_protectionsUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms/$page': {
      id: '/terms/$page'
      path: '/terms/$page'
      fullPath: '/terms/$page'
      preLoaderRoute: typeof TermsPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/account_recovery/face_verify': {
      id: '/help/account_recovery/face_verify'
      path: '/help/account_recovery/face_verify'
      fullPath: '/help/account_recovery/face_verify'
      preLoaderRoute: typeof HelpAccount_recoveryFace_verifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/account_recovery/id': {
      id: '/help/account_recovery/id'
      path: '/help/account_recovery/id'
      fullPath: '/help/account_recovery/id'
      preLoaderRoute: typeof HelpAccount_recoveryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/account_recovery/menu': {
      id: '/help/account_recovery/menu'
      path: '/help/account_recovery/menu'
      fullPath: '/help/account_recovery/menu'
      preLoaderRoute: typeof HelpAccount_recoveryMenuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/account_recovery/phone': {
      id: '/help/account_recovery/phone'
      path: '/help/account_recovery/phone'
      fullPath: '/help/account_recovery/phone'
      preLoaderRoute: typeof HelpAccount_recoveryPhoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/tutorials/market': {
      id: '/help/tutorials/market'
      path: '/help/tutorials/market'
      fullPath: '/help/tutorials/market'
      preLoaderRoute: typeof HelpTutorialsMarketRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/tutorials/public_audit': {
      id: '/help/tutorials/public_audit'
      path: '/help/tutorials/public_audit'
      fullPath: '/help/tutorials/public_audit'
      preLoaderRoute: typeof HelpTutorialsPublic_auditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template_protections/blacklist/': {
      id: '/template_protections/blacklist/'
      path: '/'
      fullPath: '/template_protections/blacklist/'
      preLoaderRoute: typeof Template_protectionsBlacklistIndexRouteImport
      parentRoute: typeof Template_protectionsBlacklistLayoutRoute
    }
    '/template_protections/blacklist/rules': {
      id: '/template_protections/blacklist/rules'
      path: '/rules'
      fullPath: '/template_protections/blacklist/rules'
      preLoaderRoute: typeof Template_protectionsBlacklistRulesRouteImport
      parentRoute: typeof Template_protectionsBlacklistLayoutRoute
    }
    '/template_protections/blacklist/self': {
      id: '/template_protections/blacklist/self'
      path: '/self'
      fullPath: '/template_protections/blacklist/self'
      preLoaderRoute: typeof Template_protectionsBlacklistSelfRouteImport
      parentRoute: typeof Template_protectionsBlacklistLayoutRoute
    }
    '/template_protections/blacklist/subscribed': {
      id: '/template_protections/blacklist/subscribed'
      path: '/subscribed'
      fullPath: '/template_protections/blacklist/subscribed'
      preLoaderRoute: typeof Template_protectionsBlacklistSubscribedRouteImport
      parentRoute: typeof Template_protectionsBlacklistLayoutRoute
    }
    '/template_protections/detail/$templateId': {
      id: '/template_protections/detail/$templateId'
      path: '/template_protections/detail/$templateId'
      fullPath: '/template_protections/detail/$templateId'
      preLoaderRoute: typeof Template_protectionsDetailTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template_protections/edit/$templateId': {
      id: '/template_protections/edit/$templateId'
      path: '/template_protections/edit/$templateId'
      fullPath: '/template_protections/edit/$templateId'
      preLoaderRoute: typeof Template_protectionsEditTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template_protections/history/received': {
      id: '/template_protections/history/received'
      path: '/template_protections/history/received'
      fullPath: '/template_protections/history/received'
      preLoaderRoute: typeof Template_protectionsHistoryReceivedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template_protections/history/sent': {
      id: '/template_protections/history/sent'
      path: '/template_protections/history/sent'
      fullPath: '/template_protections/history/sent'
      preLoaderRoute: typeof Template_protectionsHistorySentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/account/changePass': {
      id: '/user/account/changePass'
      path: '/user/account/changePass'
      fullPath: '/user/account/changePass'
      preLoaderRoute: typeof UserAccountChangePassRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/account/disable': {
      id: '/user/account/disable'
      path: '/user/account/disable'
      fullPath: '/user/account/disable'
      preLoaderRoute: typeof UserAccountDisableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/account/recovery': {
      id: '/user/account/recovery'
      path: '/user/account/recovery'
      fullPath: '/user/account/recovery'
      preLoaderRoute: typeof UserAccountRecoveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/account/recovery_phone': {
      id: '/user/account/recovery_phone'
      path: '/user/account/recovery_phone'
      fullPath: '/user/account/recovery_phone'
      preLoaderRoute: typeof UserAccountRecovery_phoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/account/updatePhone': {
      id: '/user/account/updatePhone'
      path: '/user/account/updatePhone'
      fullPath: '/user/account/updatePhone'
      preLoaderRoute: typeof UserAccountUpdatePhoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/badges/': {
      id: '/user/badges/'
      path: '/user/badges'
      fullPath: '/user/badges/'
      preLoaderRoute: typeof UserBadgesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/badges/$id': {
      id: '/user/badges/$id'
      path: '/user/badges/$id'
      fullPath: '/user/badges/$id'
      preLoaderRoute: typeof UserBadgesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/tutorials/user/app-usage': {
      id: '/help/tutorials/user/app-usage'
      path: '/help/tutorials/user/app-usage'
      fullPath: '/help/tutorials/user/app-usage'
      preLoaderRoute: typeof HelpTutorialsUserAppUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template_protections/blacklist/public/': {
      id: '/template_protections/blacklist/public/'
      path: '/public'
      fullPath: '/template_protections/blacklist/public/'
      preLoaderRoute: typeof Template_protectionsBlacklistPublicIndexRouteImport
      parentRoute: typeof Template_protectionsBlacklistLayoutRoute
    }
    '/template_protections/blacklist/public/$id': {
      id: '/template_protections/blacklist/public/$id'
      path: '/public/$id'
      fullPath: '/template_protections/blacklist/public/$id'
      preLoaderRoute: typeof Template_protectionsBlacklistPublicIdRouteImport
      parentRoute: typeof Template_protectionsBlacklistLayoutRoute
    }
  }
}

interface Template_protectionsBlacklistLayoutRouteChildren {
  Template_protectionsBlacklistRulesRoute: typeof Template_protectionsBlacklistRulesRoute
  Template_protectionsBlacklistSelfRoute: typeof Template_protectionsBlacklistSelfRoute
  Template_protectionsBlacklistSubscribedRoute: typeof Template_protectionsBlacklistSubscribedRoute
  Template_protectionsBlacklistIndexRoute: typeof Template_protectionsBlacklistIndexRoute
  Template_protectionsBlacklistPublicIdRoute: typeof Template_protectionsBlacklistPublicIdRoute
  Template_protectionsBlacklistPublicIndexRoute: typeof Template_protectionsBlacklistPublicIndexRoute
}

const Template_protectionsBlacklistLayoutRouteChildren: Template_protectionsBlacklistLayoutRouteChildren =
  {
    Template_protectionsBlacklistRulesRoute:
      Template_protectionsBlacklistRulesRoute,
    Template_protectionsBlacklistSelfRoute:
      Template_protectionsBlacklistSelfRoute,
    Template_protectionsBlacklistSubscribedRoute:
      Template_protectionsBlacklistSubscribedRoute,
    Template_protectionsBlacklistIndexRoute:
      Template_protectionsBlacklistIndexRoute,
    Template_protectionsBlacklistPublicIdRoute:
      Template_protectionsBlacklistPublicIdRoute,
    Template_protectionsBlacklistPublicIndexRoute:
      Template_protectionsBlacklistPublicIndexRoute,
  }

const Template_protectionsBlacklistLayoutRouteWithChildren =
  Template_protectionsBlacklistLayoutRoute._addFileChildren(
    Template_protectionsBlacklistLayoutRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  CertificatesRoute: CertificatesRoute,
  Template_traceRoute: Template_traceRoute,
  Template_protectionsBlacklistLayoutRoute:
    Template_protectionsBlacklistLayoutRouteWithChildren,
  EventsMcnProjectRoute: EventsMcnProjectRoute,
  F2aIdRoute: F2aIdRoute,
  F2aOtpRoute: F2aOtpRoute,
  HelpFeedbackRoute: HelpFeedbackRoute,
  NoticeSpan_warningRoute: NoticeSpan_warningRoute,
  ReportDetailRoute: ReportDetailRoute,
  ResultFailRoute: ResultFailRoute,
  ResultSuccessRoute: ResultSuccessRoute,
  Template_protectionsSendRoute: Template_protectionsSendRoute,
  Template_protectionsStorageRoute: Template_protectionsStorageRoute,
  Template_protectionsTrustedQueryRoute: Template_protectionsTrustedQueryRoute,
  Template_protectionsUploadRoute: Template_protectionsUploadRoute,
  TermsPageRoute: TermsPageRoute,
  F2aIndexRoute: F2aIndexRoute,
  HelpIndexRoute: HelpIndexRoute,
  ReportIndexRoute: ReportIndexRoute,
  Template_protectionsIndexRoute: Template_protectionsIndexRoute,
  HelpAccount_recoveryFace_verifyRoute: HelpAccount_recoveryFace_verifyRoute,
  HelpAccount_recoveryIdRoute: HelpAccount_recoveryIdRoute,
  HelpAccount_recoveryMenuRoute: HelpAccount_recoveryMenuRoute,
  HelpAccount_recoveryPhoneRoute: HelpAccount_recoveryPhoneRoute,
  HelpTutorialsMarketRoute: HelpTutorialsMarketRoute,
  HelpTutorialsPublic_auditRoute: HelpTutorialsPublic_auditRoute,
  Template_protectionsDetailTemplateIdRoute:
    Template_protectionsDetailTemplateIdRoute,
  Template_protectionsEditTemplateIdRoute:
    Template_protectionsEditTemplateIdRoute,
  Template_protectionsHistoryReceivedRoute:
    Template_protectionsHistoryReceivedRoute,
  Template_protectionsHistorySentRoute: Template_protectionsHistorySentRoute,
  UserAccountChangePassRoute: UserAccountChangePassRoute,
  UserAccountDisableRoute: UserAccountDisableRoute,
  UserAccountRecoveryRoute: UserAccountRecoveryRoute,
  UserAccountRecovery_phoneRoute: UserAccountRecovery_phoneRoute,
  UserAccountUpdatePhoneRoute: UserAccountUpdatePhoneRoute,
  UserBadgesIdRoute: UserBadgesIdRoute,
  UserBadgesIndexRoute: UserBadgesIndexRoute,
  HelpTutorialsUserAppUsageRoute: HelpTutorialsUserAppUsageRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
